import type React from 'react';

export type PaletteId = 'saffron' | 'forest' | 'cobalt';

export const PALETTES: Array<{ id: PaletteId; label: string; swatch: string; panel: string }> = [
  { id: 'saffron', label: 'Saffron', swatch: 'oklch(0.665 0.175 44)', panel: 'oklch(0.255 0.022 168)' },
  { id: 'forest', label: 'Forest', swatch: 'oklch(0.64 0.12 75)', panel: 'oklch(0.3 0.05 155)' },
  { id: 'cobalt', label: 'Cobalt', swatch: 'oklch(0.55 0.19 258)', panel: 'oklch(0.24 0.02 260)' },
];

export const QUICK_ACCENTS = ['#e8642a', '#c9a227', '#2f7d5b', '#2563c9', '#0e8a8a', '#c2415d', '#5b6470'];

export const isPaletteId = (v: unknown): v is PaletteId => PALETTES.some((p) => p.id === v);
export const isHexColour = (v: unknown): v is string => typeof v === 'string' && /^#[0-9a-f]{6}$/i.test(v);

const luminance = (hex: string) => {
  const c = [1, 3, 5].map((i) => {
    const x = parseInt(hex.substr(i, 2), 16) / 255;
    return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
};

/** CSS variables that swap the scheme's accent for the user's own colour. */
export function accentVars(hex: string | null): React.CSSProperties {
  if (!isHexColour(hex)) return {};
  return {
    ['--ot-accent' as any]: hex,
    ['--ot-accent-ink' as any]: luminance(hex) > 0.36 ? 'oklch(0.2 0.02 60)' : 'oklch(0.99 0.005 60)',
    ['--ot-accent-soft' as any]: `color-mix(in oklch, ${hex} 16%, var(--ot-surface))`,
    ['--ot-accent-text' as any]: `color-mix(in oklch, ${hex} 72%, var(--ot-ink))`,
    ['--ot-glow' as any]: `color-mix(in oklch, ${hex} 38%, transparent)`,
    ['--ot-spot' as any]: `color-mix(in oklch, ${hex} 12%, transparent)`,
  };
}
